const ecosystemAboutPegasus = {
  title: 'ЕКОСИСТЕМА PEGASUS ARMS',
  timeLine: [
    {
      title: 'ДОСЛІДЖЕННЯ ТА РОЗРОБКИ',
      description:
        'Команда інженерів та експертів безперервно вдосконалює існуючі рішення та створює нові покоління дронів.',
    },
    {
      title: 'ВЛАСНЕ ВИРОБНИЦТВО',
      description:
        'Серійна збірка з врахуванням сучасних передових військових технологій та інновацій.',
    },
    {
      title: 'НАВЧАННЯ ОПЕРАТОРІВ БпЛА/БпАК',
      description:
        'Повний курс підготовки з нуля або перепідготовка досвідчених фахівців БпЛА/БпАК Pegasus Arms 25.',
    },
    {
      title: 'ПЕРЕВІРКА БОЄМ',
      description:
        'Pegasus Arms 25 — це ударний дрон, який постійно працює на передовій та має реальний бойовий досвід.',
    },
  ],
}

export default ecosystemAboutPegasus
